import { useMediaQuery, useTheme } from "@mui/material";
import type { DeviceTier } from "@greensparks/design-system/device";

export function useDeviceTier(): DeviceTier {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
  const isTablet = useMediaQuery(theme.breakpoints.up("md"));

  if (isDesktop) return "desktop";
  if (isTablet) return "tablet";
  return "phone";
}
